import type { IconSvgObject } from './types';

const Remove01Icon: IconSvgObject = [
  ["path", { d: "M19.002 12L5.00001 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Remove01Icon;
